var _style, _g, _defs, _defs2, _defs3, _polygon, _polygon2, _polygon3, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSbCandStv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 279.82 189.15",
    style: {
      enableBackground: "new 0 0 279.82 189.15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7E7E7D;}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000025421603999126165920000003638151993601774484_);fill:url(#SVGID_00000129188344611909886100000006740186596044657818_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000093143788368272665250000018375326443212961408_);fill:url(#SVGID_00000126320805836623120940000000595808308029994409_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000060021694858615099880000011027630647652682656_);fill:url(#SVGID_00000170259752255100498070000009880855774379477433_);}\n\t.st4{fill:#8E8E8D;}\n\t.st5{fill:#7F7F7F;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "56.11,78.41 56.08,89.72 75.66,100.98 75.66,89.66  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.42,83.98l0.03,11.27c0,0,9.79-5.64,9.79-5.65V78.32L85.42,83.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.23,100.85l0.01,11.39c0,0.01-9.76,5.68-9.79,5.71l-0.01-11.35L95.23,100.85z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "105.01,87.89 102.56,89.47 102.56,93.12 105,91.55 105,95.25 105.03,117.88 134.41,134.79  134.39,123.44 114.84,112.18 114.82,78.24 134.41,89.47 134.41,78.15 105.04,61.25  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121258605250063717430000003140859325136372884_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015342671148825492270000008816058391552763580_",
    gradientUnits: "userSpaceOnUse",
    x1: -398.3487,
    y1: 377.7389,
    x2: -394.6802,
    y2: 377.7389,
    gradientTransform: "matrix(8.6807 0 0 -8.6807 3560.4985 3377.0537)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1825,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3524,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    style: {
      stopColor: "#DDDDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6793,
    style: {
      stopColor: "#C3C3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8376,
    style: {
      stopColor: "#A2A1A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9937,
    style: {
      stopColor: "#797878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#787777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787777"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 102.56,
    y: 61.25,
    style: {
      clipPath: "url(#SVGID_00000121258605250063717430000003140859325136372884_)",
      fill: "url(#SVGID_00000015342671148825492270000008816058391552763580_)"
    },
    width: 31.84,
    height: 73.54
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000177464955205776046640000011731187401403408040_",
    points: "46.3,95.41 65.84,106.7 65.89,118.03  46.29,106.73 46.3,118.06 75.68,134.95 75.67,100.98 56.08,89.72 56.11,78.41 75.67,89.66 75.63,78.34 46.3,61.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000082359853161652827700000009639687989468112535_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177464955205776046640000011731187401403408040_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141455309937141009940000012382413500972257716_",
    gradientUnits: "userSpaceOnUse",
    x1: -400.8851,
    y1: 375.7302,
    x2: -397.2164,
    y2: 375.7302,
    gradientTransform: "matrix(8.0102 0 0 -8.0102 3257.4465 3107.8318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1825,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3524,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    style: {
      stopColor: "#DDDDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6793,
    style: {
      stopColor: "#C3C3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8376,
    style: {
      stopColor: "#A2A1A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9937,
    style: {
      stopColor: "#797878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#787777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787777"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 46.29,
    y: 61.4,
    style: {
      clipPath: "url(#SVGID_00000082359853161652827700000009639687989468112535_)",
      fill: "url(#SVGID_00000141455309937141009940000012382413500972257716_)"
    },
    width: 29.39,
    height: 73.55
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000034771825388828531250000014592489600312196286_",
    d: "M85.46,106.61l9.79-5.74l0.01,11.39l-9.79,5.71 L85.46,106.61z M85.43,83.98c0.02-0.01,9.82-5.66,9.82-5.66V89.6c0-0.01-9.79,5.65-9.79,5.65L85.43,83.98z M75.63,78.34 l0.05,56.61l29.35-17.06L105,91.55l-2.44,1.57v-3.65l2.44-1.58l0.03-26.64L75.63,78.34z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106839744999599794230000009406926577620791721_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034771825388828531250000014592489600312196286_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168097540530310818420000011867083595868669855_",
    gradientUnits: "userSpaceOnUse",
    x1: -398.2434,
    y1: 375.7555,
    x2: -394.5747,
    y2: 375.7555,
    gradientTransform: "matrix(8.0159 0 0 -8.0159 3267.927 3110.136)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1825,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3524,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    style: {
      stopColor: "#DDDDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6793,
    style: {
      stopColor: "#C3C3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8376,
    style: {
      stopColor: "#A2A1A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9937,
    style: {
      stopColor: "#797878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#787777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#787777"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 75.63,
    y: 61.25,
    style: {
      clipPath: "url(#SVGID_00000106839744999599794230000009406926577620791721_)",
      fill: "url(#SVGID_00000168097540530310818420000011867083595868669855_)"
    },
    width: 29.41,
    height: 73.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "46.3,106.73 65.89,118.03 65.84,106.7 56.09,101.07  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "124.65,83.87 114.82,78.24 114.84,112.18 134.4,123.44 134.41,134.79 144.2,129.11 144.2,117.76  124.62,106.49  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "105.04,49.93 75.67,67.06 56.09,55.75 46.29,61.4 75.63,78.34 105.04,61.25 134.4,78.15 134.4,89.47  144.19,83.78 144.19,72.65  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M175.78,96.57c9.13,0.21,16.61,5.84,22.64,10.03l6.57,4.96c-1.16,1.29-2.27,2.48-3.34,2.88 c0.76,0.92,2.25,1.12,3.3,0.45c0.68-0.44,1.37-1.09,2.07-1.8l4.54,3.49c0,0,1.7,1.54,3.74,0.73c2.01-0.79,1.3-4.15-1.98-3.79 c-0.48,0.05-0.96-0.08-1.34-0.34c-0.7-0.5-1.27-0.97-2.96-2.23c1.04-1.11,2.06-2.11,3.03-2.56c-0.64-0.78-1.87-1.08-2.84-0.61 c-0.76,0.35-1.5,0.96-2.22,1.67c-2.9-2.16-5.95-4.46-7.16-5.39c-5.24-4.04-12.32-8.86-18.69-8.86 C179.26,95.19,177.46,95.6,175.78,96.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M197.95,72.78c-3.67-2.28-6.56-2.01-6.56-2.01c2.79,1.31,4.51,3.19,4.51,3.19c-6.77-1.6-9.73,0.69-9.73,0.69 c4.24-0.6,5.21,1.2,5.21,1.2c-6.81-0.19-9.02,4.97-9.02,4.97c3.82-2.84,8.11-1.52,8.11-1.52c-9.05,4.06-8.45,11.81-8.45,11.81 c2.14-3.66,5.17-6.03,8.69-6.79c-3,5.28-0.96,10.22-0.96,10.22c3.21-7.3,6.17-9.35,7.86-9.95v15.38l1.58,1.36l1.52-1.3V84.55 c1.68,0.56,4.51,2.34,7.86,9.99c0,0,2.04-4.94-0.96-10.22c3.52,0.76,6.55,3.13,8.69,6.79c0,0,0.6-7.75-8.45-11.81 c0,0,4.3-1.32,8.11,1.52c0,0-2.21-5.15-9.02-4.97c0,0,0.96-1.8,5.2-1.2c0,0-2.96-2.29-9.73-0.69c0,0,1.72-1.88,4.51-3.19 c0,0-2.89-0.27-6.56,2.01c-0.37-1.38-0.77-2.7-1.22-3.95C198.73,70.08,198.32,71.4,197.95,72.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179.31,56.8c-2.78,0-5.13,1.8-5.98,4.29h56.73v56.76c2.49-0.85,4.28-3.2,4.28-5.97l0.03-55.07H179.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M181.4,138.26h1.75v-1.75h-1.75V138.26z M180.27,125.19h-1.75v1.75h1.75V125.19z M177.74,125.19h-1.75v1.75 h1.75V125.19z M183.93,138.26h1.75v-1.75h-1.75V138.26z M191.52,128.04h-0.85c-0.89,0-1.61,0.72-1.61,1.61h2.35 c1.52,0,2.23,0.7,2.23,2.2v1.98h-5.87v1.6h7.54v-3.47C195.32,129.39,194.01,128.04,191.52,128.04 M232.7,122.79v12.62h1.68v-10.95 C234.37,123.55,233.62,122.79,232.7,122.79 M229.24,122.79v11.02h-3.21v-5.78h-1.67v5.78h-2.01v-4.94h-1.67v4.94h-2.01v-4.16H217 v4.16l-3.57-0.01l1.65-2.69l-0.1-0.25c-0.08-0.21-0.18-0.41-0.28-0.6c-0.26-0.45-0.63-0.86-1.09-1.23 c-0.14-0.12-0.28-0.22-0.43-0.32c-0.1-0.07-0.17-0.11-0.21-0.13c-0.55-0.31-1.13-0.49-1.73-0.53c-0.21-0.01-0.42-0.02-0.62,0 c-0.63,0.06-1.22,0.24-1.75,0.54c-0.72,0.39-1.29,0.96-1.7,1.67c-0.11,0.19-0.21,0.39-0.3,0.6l-0.1,0.25l0.52,0.85l1.13,1.84 l-3.82,0.01v-5.78h-3.21c-2.56,0-3.98,1.51-3.98,4.24v3.14h5.5c-0.09,1.61-0.74,2.22-2.29,2.22h-0.7c-0.89,0-1.61,0.72-1.61,1.6 h2.74c2.09,0,3.36-1.39,3.5-3.83h26.35v-10.95C230.91,123.55,230.17,122.79,229.24,122.79 M202.92,133.82h-3.83v-1.52 c0-1.81,0.73-2.65,2.3-2.65h1.53V133.82z M211.54,133.81h-1.24l-1.68-2.75l0.07-0.1c0.53-0.8,1.28-1.22,2.23-1.26 c0.98,0.04,1.73,0.46,2.25,1.26l0.07,0.1L211.54,133.81z M184.03,128.04v5.78h-3.78v-5.78h-2.94c-2.56,0-3.98,1.51-3.98,4.24v3.14 h12.35v-5.72C185.68,128.78,184.94,128.04,184.03,128.04 M178.58,133.82h-3.57v-1.52c0-1.81,0.73-2.65,2.3-2.65h1.27V133.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198.58,104.05c-1.21,0.93-4.27,3.23-7.16,5.39c-0.72-0.7-1.46-1.31-2.22-1.67c-0.97-0.46-2.2-0.17-2.84,0.62 c0.97,0.45,1.99,1.45,3.04,2.56c-1.69,1.25-2.27,1.72-2.96,2.22c-0.37,0.27-0.85,0.4-1.33,0.35c-3.28-0.36-4,3-1.99,3.79 c2.04,0.8,3.74-0.73,3.74-0.73l4.54-3.49c0.7,0.72,1.39,1.36,2.07,1.8c1.05,0.68,2.54,0.47,3.29-0.45 c-1.07-0.4-2.18-1.59-3.34-2.88l6.57-4.96c6.03-4.2,13.51-9.82,22.64-10.03c-1.68-0.97-3.48-1.38-5.34-1.38 C210.9,95.19,203.82,100.01,198.58,104.05"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbCandStv);
export default __webpack_public_path__ + "static/media/SBCandStv.9c4589c93a260febe94c42e78717e01c.svg";
export { ForwardRef as ReactComponent };